import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { AccountLink } from "./AccountLink";
import * as styles from "./AccountPopover.styles";
import { FAVOURITES_PAGE_HREF } from "../../../constants/hrefs";
export var AnonymousAccountLinks = function AnonymousAccountLinks(_ref) {
  var includeFavourites = _ref.includeFavourites;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.sections
  }, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(_StyledH, {
    $_css2: styles.title
  }, "Returning customer?"), /*#__PURE__*/React.createElement(AccountLink, {
    href: "/u/sign-in",
    text: "Sign in"
  })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(_StyledH2, {
    $_css3: styles.title
  }, "New here?"), /*#__PURE__*/React.createElement(AccountLink, {
    href: "/u/register",
    text: "Register"
  })), includeFavourites && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(_StyledSection, {
    $_css4: styles.smallScreensOnly
  }, /*#__PURE__*/React.createElement(AccountLink, {
    href: FAVOURITES_PAGE_HREF,
    text: "My Favourites"
  }))));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledH = _styled2("h3")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledH2 = _styled3("h3")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledSection = /*#__PURE__*/_styled4("section").withConfig({
  displayName: "AnonymousAccountLinks___StyledSection",
  componentId: "sc-1nu4te7-0"
})(["", ""], function (p) {
  return p.$_css4;
});